import { Box, Button, ButtonBase, IconArrowRight16, Link } from '@stitch-fix/mode-react';
import { useClientAuth } from '@stitch-fix/sf-next';
import { useState } from 'react';
import type { ModularComponent } from '../../components/ModularPageWrapper/ModularPageWrapper';
import { useAuthGatedCallback } from '../../hooks/useAuthGatedCallback';
import { buttonColorToButtonVariant } from '../../components/ModuleFooter/ModuleFooter';
export const useGiftCardModules = ({
  modules
}: {
  modules: ModularComponent[];
}) => {
  const {
    authStatus
  } = useClientAuth();
  const [activeWizard, setActiveWizard] = useState<'buy' | 'redeem' | null>(null);
  const gatedOpenRedeemWizard = useAuthGatedCallback(() => setActiveWizard('redeem'));
  const renderGiftCardCta = ({
    buyButtonColor
  }: {
    buyButtonColor?: string;
  }) => {
    return <Box style={{
      display: 'flex',
      gap: '1rem',
      flexDirection: 'column',
      maxWidth: '250px',
      margin: '0 auto'
    }}>
        <Button variant={buttonColorToButtonVariant(buyButtonColor)} onClick={() => setActiveWizard('buy')}>
          Buy a Gift Card
        </Button>

        <Button variant="outline-large" disabled={authStatus === 'loading'} onClick={gatedOpenRedeemWizard}>
          Redeem a Gift Card
        </Button>
      </Box>;
  };
  const overrideModules = (_modules: ModularComponent[]) => {
    return _modules.map(module => {
      if (module.type === 'hero') {
        return {
          ...module,
          props: {
            ...module.props,
            items: module.props.items?.map(item => ({
              ...item,
              CtaButton: renderGiftCardCta({
                buyButtonColor: item.buttonColor
              })
            }))
          }
        };
      }
      if (module.type === 'galleryHero') {
        return {
          ...module,
          props: {
            ...module.props,
            items: module.props.items?.map(item => ({
              ...item,
              CtaButton: renderGiftCardCta({
                buyButtonColor: module.props.buttonColor
              })
            }))
          }
        };
      }
      if (module.type === 'displaySplit') {
        return {
          ...module,
          props: {
            ...module.props,
            CTAButton: <Link as={ButtonBase} size="tertiary" endIcon={<IconArrowRight16 />} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();
              setActiveWizard('buy');
            }}>
                Buy a gift card
              </Link>
          }
        };
      }
      return module;
    });
  };
  return {
    modules: overrideModules(modules),
    activeWizard,
    setActiveWizard
  };
};